<template>
  <header id="et-header" class="main-header">
    <div class="static-menu">
      <div class="brand-on-mobile" @click="toggleNav()">
        <ETLogo></ETLogo>
      </div>
      <div class="brand" @click="hangelLogoClick">
        <ETLogo></ETLogo>
        <ETLogoText></ETLogoText>
      </div>
    </div>
    <div class="dynamic-menu">
      <component :is="currentPageMenu"></component>

      <div class="user-menu">
        <!-- <div v-if="mode"  @click="toggle">
            <img class="avatar" :src="userData && userData.profilePicture? userData.profilePicture:'/img/avatar.png'" />
            <select v-model="user" class="name" @change="changeUser">
              <option value="" disabled selected>Select user</option>
              <option v-for="(user, index) in users" :key="index" :value="user._id">{{ user.fullname }}</option>
            </select>
          </div>-->
        <div v-if="!isLogin" class="nonlogin-menu">
          <li v-show="false">
            <a
              href="https://app.experiencethis.co/marketplace/subtheme/5f314f0fdc534700315e8ed9"
              target="_blank"
            >
              EXPERIENCES
            </a>
          </li>
          <li>
            <a href="https://experiencethis.co/how-it-works" target="_blank">
              HOW IT WORKS
            </a>
          </li>
          <li>
            <a href="/account/signin"> LOGIN </a>
          </li>
          <li v-show="false">
            <a href="/account/signup"> SIGN UP </a>
          </li>
        </div>
        <div v-if="isLogin">
          <VenueProfile
            v-if="venueProfile() && $store.state.account.bookFor"
          />
        </div>
        <div v-if="isLogin" class="name">
          <DropdownMenuNew
            class="user-menu-dropdown"
            :user="userData"
            :disabled-view-profile-options="disabledViewProfileOptions"
          ></DropdownMenuNew>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ETLogo from '@/components/ui/ETLogo'
import ETLogoText from '@/components/ui/ETLogoText'
import VenueNavMenu from '@/components/nav_menu/VenueNavMenu'
import SearchBox from '@/components/search_&_filter/SearchBox'

import getVenueData from '../graphql/account/getVenueData.graphql'

import DropdownMenuNew from './ui/menu/DropdownMenu-New-User'
import VenueProfile from './../views/venue/profile/VenueProfile'
import {
  isPermitToBooking,
  handleRedirectUrl,
  isRouteRateAndReview,
} from '@/helpers/checkPermitRoute'

import { setUserRole, setUserGroup } from '@/helpers/localStorage'

export default {
  name: 'MainNav',
  components: {
    ETLogo,
    ETLogoText,
    VenueNavMenu,
    SearchBox,
    DropdownMenuNew,
    VenueProfile,
  },
  props: ['users', 'toggleNav'],

  data() {
    return {
      // Status Checkers
      user: '',
      show: false,
      userData: this.$store.getters['account/userData'],
      disabledViewProfileOptions: false,
      deviceType: 'Desktop',
    }
  },
  computed: {
    currentPageMenu() {
      let result
      switch (this.$route.name) {
        case 'venue experience profile':
        case 'venue book':
          result = VenueNavMenu
          break
      }
      return result
    },
    isLogin() {
      const { _id = '' } = this.userData || {}
      return _id
    },
  },
  async created() {
    if (this.isLogin) {
      this.userData = await this.getVenueData()
    }
  },
  mounted() {
    this.getDeviceType()
  },
  updated() {
    const reg = /(\b\w*venue[/]create\w*\b)/g
    this.disabledViewProfileOptions = reg.test(
      this.$router.currentRoute.fullPath
    )
    this.userData = this.$store.getters['account/userData']
  },

  methods: {
    toggle() {
      this.show = !this.show
    },

    hangelLogoClick() {
      if (!isRouteRateAndReview(this.$router.currentRoute.fullPath)) {
        const {
          _id = null,
          isOnboarding = true,
          teamMember = {},
          companies = [],
        } = this.userData

        if (!_id) {
          window.location = 'https://experiencethis.co/'
        }
        const role = teamMember ? teamMember.role : null
        const type = companies[0].type
        const route = handleRedirectUrl({ type, role, isOnboarding })
        // Avoid sentry error duplicate route.
        if (this.$route.path !== route) {
          this.$router.push(route)
        }
      }
    },

    venueProfile() {
      return isPermitToBooking(this.$route)
    },
    getVenueData() {
      return this.$apollo
        .query({
          query: getVenueData,
          variables: {},
        })
        .then(({ data }) => {
          const userData = data && data.getVenueData

          if (!userData) {
            return
          }

          this.$store.dispatch('account/STORE_USER', userData)
          const role = userData.teamMember ? userData.teamMember.role : null

          // Store userid in localStorage
          // Store user group in localStorage
          if (userData.companies.length) {
            const groupType = userData.companies[0].type
            setUserRole(role)
            setUserGroup(groupType)
          }
          return userData
        })
    },
    getDeviceType() {
      if (navigator.userAgentData && navigator.userAgentData.mobile) {
        this.deviceType = 'Mobile'
      } else if (navigator.userAgentData && navigator.userAgentData.tablet) {
        this.deviceType = 'Tablet'
      } else if (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === 'macOS') {
        this.deviceType = 'Mac'
      } else if (navigator.userAgent) {
        if (
          /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
          )
        ) {
          this.deviceType = 'Mobile'
        }
        if (
          /iPad/i.test(
            navigator.userAgent
          )
        ) {
          this.deviceType = 'iPad'
        }
        if (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /Mac/.test(navigator.userAgent)
        ) {
          this.deviceType = 'iPad'
        }
      }
      console.log('Device Type:', this.deviceType)
    }
  },
}
</script>

<style lang="scss" scoped>
.nonlogin-menu {
  display: flex;
  justify-content: flex-end;
  flex: 1;
  li {
    display: inline;
    margin-left: 10px;
    @include sm() {
      margin-left: 20px;
    }
  }
  li a {
    font-size: 12px !important;
    display: block;
    color: white !important;
    text-decoration: none;
    @include sm() {
      font-size: 16px !important;
    }
  }
}
.main-header {
  position: fixed;
  display: flex;
  top: 0;
  width: 100%;
  z-index: 110;
  background-color: $shade10;
  max-height: 80px;
  padding: 23px 26px;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  align-items: center;

  .brand {
    cursor: pointer;
    @include for-mobile-to-tablet {
      display: none;
    }
  }

  .brand-on-mobile {
    display: none;
    @include for-mobile-to-tablet {
      display: block;
      cursor: pointer;
    }
  }

  @include for-mobile {
    padding: 12px 16px;
  }

  & :deep(.ETLogo)  {
    margin-right: 2rem;
  }

  > .static-menu {
    display: flex;
    align-items: center;
    font-size: 2rem;
    > .brand > a {
      color: $secondary;
      text-decoration: none;
      font: {
        weight: 600;
        style: italic;
      }
    }
    > .search {
      margin-left: 24px;
    }
  }
  > .dynamic-menu {
    display: flex;
    align-items: center;
    color: #959595;
    flex: 1;
    > .main-menu {
      margin-right: 66px;
    }
    > .user-menu {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: flex-end;
      flex: 1;
      cursor: pointer;
      .avatar {
        width: 35px;
        height: 35px;
        background-color: #d9d9d9;
        border-radius: 50%;
        margin-right: 19px;
      }
      > .name {
        color: #959595;
        font-size: 1.6rem;
        outline: none;

        @include for-mobile {
          width: 50px;
        }

        .user-menu-dropdown {
          flex: 0 0 1rem;

          width: 100%;
          height: 100%;
        }
      }
      > .options {
        padding: 0;
        margin-top: 20px;
        left: 0;
        top: 100%;
      }
    }
  }
}
</style>
